module.exports = __webpack_public_path__ + "img/cq2b50-75.prt.f4e4d1b8.jpg";